<template>
    <Head>
        <title>{{ titulo }}</title>
    </Head>
</template>
<script>
export default {
    props:{
        titulo :String,
    }
}
</script>
<style>

</style>
